import React, { Component } from "react";
import { connect } from "react-redux";
import AdvancedManagementIndicateUser from "../template/AdvancedManagementIndicateUser";
import AdvancedManagementPartakers from "../template/AdvancedManagementPartakers";
import Modal from "../../../../shared/Modal/Modal";
import Button from "../../../../shared/button/button";
import { bindActionCreators } from "redux";
import Callout from "../../../../shared/Callout/Callout";
import AdvancedManagementFilter from "../template/filter/AdvancedManagementFilter";
import {
	onFilter,
	setDataToStoreDocuments,
	onSendDocuments,
	onCancelRelationship,
	cleanInviteParticipant,
	cleanErrorCancelRelationship
} from "../../../actions/advanced-management";
import { withGetScreen } from "react-getscreen";
import Loading from "../../../../shared/Loading/Loading";
import ModalTerms from "../../../../shared/ModalTerms/ModalTerms";
import { BOTH_DECLARATIONS, renderTermsDescription } from "./../../../shared/terms";
import { TermsProvider } from "../../../../shared/Terms/TermsProvider";
import { publish } from "pubsub-js";
import eventType from "../../../events/eventType";
import { ACCOUNT_FAMILY_EVENT } from "../../../events/ga/events";

class AdvancedManagementHome extends Component {
	constructor(props) {
		super(props);

		this.state = {
			showCancelRelationshipModal: false,
			showCancelIndicationModal: false,
			showCancelModalErrorOffersActive: false,
			showDisapproveRelationshipModal: false,
			ifRenderIndicationByCPF: false,
			ifRenderModalTerms: false
			// downloadMenu: false
		};

		this.closeCancelRelationshipModal = this.closeCancelRelationshipModal.bind(this);
		this.cancelModalErrorOffersActive = this.cancelModalErrorOffersActive.bind(this);
		// this.handleClickOutside = this.handleClickOutside.bind(this);
	}

	openCancelRelationshipModal = data => {
		if (data.evaluated) {
			this.setState({
				data,
				showCancelRelationshipModal: true
			});
		} else {
			this.setState({
				data,
				showCancelIndicationModal: true
			});
		}
	};

	closeCancelRelationshipModal = () => {
		this.setState({
			data: undefined,
			showCancelRelationshipModal: false,
			showCancelIndicationModal: false
		});

		if (this.props.errorCancelRelationship) {
			switch (this.props.errorCancelRelationship) {
				case "User has offers on sale":
					this.cancelModalErrorOffersActive();
					break;
				case "Can not find user offers on API":
					// Erro na API
					break;
				default:
					false;
			}
			this.props.cleanErrorCancelRelationship();
		}
	};

	cancelModalErrorOffersActive = () => {
		this.setState({
			showCancelModalErrorOffersActive: !this.state.showCancelModalErrorOffersActive
		});
	};

	confirmCancelRelationshipModal = () => {
		const { data } = this.state;
		this.props.onCancelRelationship(
			{
				relationId: data._id,
				idParticipant: data.idParticipant
			},
			() => this.closeCancelRelationshipModal()
		);

		publish(eventType.ACCOUNT_FAMILY, {
			type: ACCOUNT_FAMILY_EVENT.button_reprove_indication
		})
	};

	openDisapproveRelationshipModal = data => {
		this.setState({
			data,
			showDisapproveRelationshipModal: true
		});
	};

	closeDisapproveRelationshipModal = () => {
		this.setState({
			showDisapproveRelationshipModal: false
		});
	};

	confirmDisapproveRelationshipModal = () => {
		const { data } = this.state;
		this.props.onCancelRelationship(
			{
				relationId: data._id,
				idParticipant: data.idParticipant
			},
			() => this.closeDisapproveRelationshipModal()
		);

		publish(eventType.ACCOUNT_FAMILY, {
			type: ACCOUNT_FAMILY_EVENT.button_indicate_participant
		})
	};

	onRenderIndicationByCPF = () => {
		this.props.cleanInviteParticipant();
		this.setState({
			ifRenderIndicationByCPF: !this.state.ifRenderIndicationByCPF
		});
	};

	componentWillReceiveProps(props) {
		if (props.isFailureLimitReached || props.isInvitationLimitReached) {
			this.setState({
				ifRenderIndicationByCPF: false
			});
		}
	}

	onChangeDocuments = (event, document) => {
		this.props.setDataToStoreDocuments({
			docs: [
				{
					type: document,
					fileBase64: event
				}
			]
		});
	};

	onRenderModalTerms = () => {
		this.setState({
			ifRenderModalTerms: !this.state.ifRenderModalTerms
		});
	};

	// handleDownloadMenu = () => {
	// 	// Adiciona e remove o evento para escutar o click fora do componente
	// 	if (!this.state.downloadMenu) window.addEventListener("mousedown", this.handleClickOutside);
	// 	else window.removeEventListener("mousedown", this.handleClickOutside);

	// 	this.setState({
	// 		downloadMenu: !this.state.downloadMenu
	// 	});
	// };

	// handleClickOutside(event) {
	// 	if (!this.downloadMenuInst.contains(event.target)) this.handleDownloadMenu();
	// }

	// clickOnDownloadMenu = ev => {
	// 	this.handleDownloadMenu();
	// };

	render() {
		const {
			ifRenderConfirmDisapproveModal,
			ifRenderIndicationByCPF,
			showDisapproveRelationshipModal,
			showCancelRelationshipModal,
			showCancelIndicationModal,
			showCancelModalErrorOffersActive,
			ifRenderModalTerms
		} = this.state;
		const {
			isFailureLimitReached,
			isInvitationLimitReached,
			dataRelationship,
			filteredStatements,
			isLoading,
			nextStep
		} = this.props;
		let hasDataRelationship = dataRelationship.length > 0 ? true : false;

		if (isLoading.onSearchByRelationship) {
			return (
				<div className="advanced-management__loading">
					<Loading />
				</div>
			)
		}

		return (
			<div className="advanced-management-home">
				<div className="advanced-management-home__action">
					{!ifRenderIndicationByCPF &&
						hasDataRelationship && (
							<>
								<div className="advanced-management-home__row_pills">
									<AdvancedManagementFilter
										isTablet={this.props.isTablet()}
										isMobile={this.props.isMobile()}
										filteredStatements={this.props.filteredStatements}
										changeFilter={this.props.onFilter}
										dataRelationship={dataRelationship || []}
									/>
									{/* <div className="advanced-management-home--buttons"> */}
									{/* <Button
										onClick={this.handleDownloadMenu}
										className="btn-green-md advanced-management-home--buttons--declaration-export-button"
										data-toggle="tooltip"
										title="Download declarações"
									>
										<i className="icon-export" />
									</Button>
									{this.state.downloadMenu && (
										<div className="download-menu" ref={inst => (this.downloadMenuInst = inst)}>
											<a
												className="btn-green-md-icon download-menu--button"
												href={MANAGER_DECLARATION}
												onClick={e => this.clickOnDownloadMenu(e)}
												target="_blank"
											>
												Declaração Gestor
											</a>
											<a
												className="btn-green-md-icon download-menu--button"
												href={PARTICIPANT_DECLARATION}
												onClick={e => this.clickOnDownloadMenu(e)}
												target="_blank"
											>
												Declaração Participante
											</a>
										</div>
									)} */}

									<Button
										className="btn-primary-lg"
										disabled={isFailureLimitReached || isInvitationLimitReached}
										onClick={() => {
											this.onRenderIndicationByCPF();
											publish(eventType.ACCOUNT_FAMILY, { 
												type: ACCOUNT_FAMILY_EVENT.button_indicate_participant
											})
										}}
									>
										Indicar participante
									</Button>
								</div>
								{/* </div> */}
								<div className="advanced-management-home--declarations">
									<a
										href={BOTH_DECLARATIONS}
										target="_blank"
										onClick={() => {
											publish(eventType.ACCOUNT_FAMILY, {
												type: ACCOUNT_FAMILY_EVENT.button_download
											})
										}}
									>
										<i className="icon-export" />
										Baixar Declaração de Vínculo
									</a>
								</div>
							</>
						)}

					<AdvancedManagementIndicateUser
						ifShow={ifRenderIndicationByCPF || !hasDataRelationship}
						onRender={this.onRenderIndicationByCPF}
						onCancel={() => nextStep(2)}
						onRenderModalTerms={this.onRenderModalTerms}
					/>
				</div>

				{(isFailureLimitReached || isInvitationLimitReached) && (
					<div className="advanced-management-home__callouts">
						<Callout
							show={isFailureLimitReached}
							danger
							text={
								<span>
									<strong>CPF não encontrado ou inválido.</strong> Você excedeu o limite de 3
									tentativas por dia.
								</span>
							}
						/>

						<Callout
							show={isInvitationLimitReached}
							warn
							text={
								<span>
									<strong>Você atingiu o limite máximo de 10 indicações por dia.</strong> Aguarde até
									amanhã para indicar mais participantes.
								</span>
							}
						/>
					</div>
				)}

				{hasDataRelationship &&
					dataRelationship.map((item, index) => {
						if (
							item.status &&
							(filteredStatements.value === 0 || item.status.status === filteredStatements.value)
						) {
							return (
								<AdvancedManagementPartakers
									data={item}
									key={index}
									onDisapprove={this.openDisapproveRelationshipModal}
									onCancel={this.openCancelRelationshipModal}
								/>
							);
						}
					})}
				{ifRenderModalTerms && (
					<TermsProvider slug="family-account-manager">
						{({ content, loading, error }) => (
							<ModalTerms
								ifShow={ifRenderModalTerms}
								onClose={this.onRenderModalTerms}
								dataDescription={renderTermsDescription({ loading, error, content })}
							></ModalTerms>
						)}
					</TermsProvider>
				)}
				<Modal
					show={showDisapproveRelationshipModal}
					fixed={true}
					cancel="Voltar"
					confirm="Reprovar solicitação"
					title="Reprovar solicitação"
					description={
						isLoading.onCancelRelationship ? (
							<Loading />
						) : (
							`Para rejeitar esta solicitação de vínculo clique em Reprovar solicitação.`
						)
					}
					onCancel={this.closeDisapproveRelationshipModal}
					onConfirm={this.confirmDisapproveRelationshipModal}
				/>
				<Modal
					show={showCancelRelationshipModal}
					fixed={true}
					cancel="Desvincular"
					confirm="Manter vínculo"
					title="Desvincular conta"
					description={
						isLoading.onCancelRelationship ? (
							<Loading />
						) : (
							`Você tem certeza que deseja desfazer o vínculo de contas?`
						)
					}
					onCancel={this.confirmCancelRelationshipModal}
					onConfirm={this.closeCancelRelationshipModal}
					withoutClose={true}
				/>
				<Modal
					show={showCancelIndicationModal}
					fixed={true}
					cancel="Excluir"
					confirm="Manter indicação"
					title="Excluir indicação"
					description={
						isLoading.onCancelRelationship ? (
							<Loading />
						) : (
							`Você tem certeza que deseja excluir a indicação deste participante?`
						)
					}
					onCancel={this.confirmCancelRelationshipModal}
					onConfirm={this.closeCancelRelationshipModal}
					withoutClose={true}
				/>
				<Modal
					show={showCancelModalErrorOffersActive}
					fixed={true}
					confirm="Ok, entendi"
					title="Atenção!"
					description="Não é possível desvincular sua conta, pois o participante tem uma oferta ativa nesse momento."
					onConfirm={this.cancelModalErrorOffersActive}
				/>
			</div>
		);
	}
}

const mapStateToProps = state => ({
	...state.advancedManagement
});

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			onFilter,
			setDataToStoreDocuments,
			onSendDocuments,
			onCancelRelationship,
			cleanInviteParticipant,
			cleanErrorCancelRelationship
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps)(
	withGetScreen(AdvancedManagementHome, {
		mobileLimit: 468,
		tabletLimit: 768,
		shouldListenOnResize: true
	})
);
